/* eslint-disable jsx-a11y/no-autofocus */

import { FC, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Link } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';

import { DetailedTransactionFragment } from '../graphql/fragment/detailedTransaction.gql';
import useUpdateTransactionNoteMutation from './hooks/useUpdateTransactionNoteMutation';
import locales from './locales';

interface NoteProps {
  transactionId: string;
  note: NonNullable<DetailedTransactionFragment['note']>;
}

const Note: FC<NoteProps> = ({ note, transactionId }) => {
  const [isEditing, setEditing] = useState(false);
  const [updateTransactionNote] =
    useUpdateTransactionNoteMutation(transactionId);

  const { handleSubmit, register } = useForm({
    defaultValues: { note },
  });

  return (
    <form
      onSubmit={handleSubmit((values) => {
        updateTransactionNote(values.note);
        setEditing(false);
      })}
    >
      <SunshineCard
        isBoxed={false}
        onClick={() => {
          setEditing(true);
        }}
        padding="space-24"
        position="relative"
        title={note ? locales.note : locales.addNote}
      >
        <SunshineCard.Content paddingY={isEditing ? 'space-24' : 'space-0'}>
          {isEditing ? (
            <Form.Input {...register('note')} autoFocus />
          ) : (
            <Text paddingTop={note ? 'space-8' : 'space-0'}>
              {note ?? undefined}
            </Text>
          )}
        </SunshineCard.Content>

        <Box position="absolute" right="space-24" top="space-24">
          {/* eslint-disable-next-line no-nested-ternary */}
          {isEditing ? (
            <Link as="button" size="sm" type="submit">
              Ok
            </Link>
          ) : (
            <SunshineIcon
              name={note ? 'edit' : 'chevron-right'}
              size="icon-24"
            />
          )}
        </Box>
      </SunshineCard>
    </form>
  );
};

export default Note;
